import React, { useContext } from "react";
import { Button, Flex, Layout, Result, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie";
import * as animationData from "../../assets/animation_loader.json";
import "./index.scss";
import LoaderContext from "../../Context/LoaderContext/Index";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const handleGoToHome = () => {
    navigate("/");
  };
  const { isLoading } = useContext(LoaderContext);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Flex align="center" justify="center" style={{flexDirection: "column", height: "100vh"}}>
      <Lottie options={defaultOptions} height={300} width={300} />
      <Typography.Title level={1}>404</Typography.Title>
      <Typography.Paragraph>
        Sorry, the page you visited does not exist.
      </Typography.Paragraph>
      <Button type="primary" onClick={handleGoToHome} loading={isLoading}>
        Back Home
      </Button>
    </Flex>
  );
};

export default NotFound;
